var paints = [
    // 'dist/browser/assets/blob.js',
]
if (window.CSS['paintWorklet']) {
    paints.forEach(paint => window.CSS['paintWorklet'].addModule(paint));
}
